class AIFlags {
    constructor() {
      this.flags = [];
    }
  };
  
  const aiproFlags = new AIFlags();
  
  export { aiproFlags };
